// src/services/auth-header.ts
export default function authHeader(): Record<string, string> {
  // Try to get token directly (this is how auth.service.ts stores it)
  const token = localStorage.getItem('token');
  
  // Also try to get from user object for backward compatibility
  const userStr = localStorage.getItem('user');
  let user = null;
  
  // If direct token exists, use it
  if (token) {
    console.log('Using direct token from localStorage');
    return { Authorization: `Bearer ${token}` };
  }
  
  // Otherwise try to get from user object
  if (userStr) {
    try {
      user = JSON.parse(userStr);
      console.log('Auth header - parsed user:', { 
        hasUser: !!user, 
        hasToken: !!(user && user.accessToken)
      });
    } catch (e) {
      console.error('Error parsing user data from localStorage', e);
      localStorage.removeItem('user');
      return {};
    }
  } else {
    console.warn('No user data found in localStorage');
  }

  if (user && user.accessToken) {
    console.log('Returning auth header with token from user.accessToken');
    return { Authorization: `Bearer ${user.accessToken}` };
  } else if (user && user.token) {
    // Alternative token field name (sometimes used)
    console.log('Returning auth header with token from user.token');
    return { Authorization: `Bearer ${user.token}` };
  } else {
    console.warn('No valid token found for authorization');
    return {};
  }
}
